var exports = {
  "k": "xe564cbfb--4ca6ef--container",
  "v": "xe564cbfb--4ca6ef--portal",
};

module.exports = exports;
